import {graphql} from 'gatsby'
import React from 'react'

import type {
    MediaItemGridSliceFragment,
    CustomerCaseMediaItemGridFragment,
    PartnerTemplateMediaItemGridFragment,
} from '@/graphql-types'
import TitleWithMediaItemsSection from '@/sections/title-with-media-items'
import {BackgroundWrapper} from '@/styles/grid'
import {isValidBackgroundColor} from '@/utils/is-valid-background-color'

type Props = {
    slice:
        | MediaItemGridSliceFragment
        | CustomerCaseMediaItemGridFragment
        | PartnerTemplateMediaItemGridFragment
    dataTestId?: string
}

export const MediaItemGridSlice = ({slice, dataTestId}: Props) => {
    const items = slice.items.map((mediaItem) => ({
        title: mediaItem.item_title,
        body: mediaItem.item_description.richText,
        image: mediaItem.image,
    }))

    const color = isValidBackgroundColor(slice.primary.background)
        ? slice.primary.background
        : 'default'

    return (
        <BackgroundWrapper $color={color}>
            <TitleWithMediaItemsSection
                title={slice.primary.title}
                variant={slice.primary.layout === 'two_columns' ? 'two-equal' : 'three-equal'}
                items={items}
                dataTestId={dataTestId}
            />
        </BackgroundWrapper>
    )
}

export const mediaItemGridSliceFragment = graphql`
    fragment MediaItemGridSlice on PrismicSlicePageDataBodyMediaItemGrid {
        __typename
        primary {
            title
            layout
            background
        }
        items {
            image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
            }
            item_title
            item_description {
                richText
            }
        }
    }
`
